import React from "react";

import { AW21 } from "../../../../js/database/database-aw21.js";

import TopMenuProducts from "../../../../components/topmenuproducts";
import SwiperInit from "../../../../components/SwiperInit";
import InfoItem from "../../../../components/infoItem";
import Loader from "../../../../components/loader";

import ShopifyMainComponent from "../../../../components/ShopifyMainComponent";
import GlobalMetaTags from "../../../../components/globalMetaTags";
import SizeChart from "../../../../components/sizeChart.js";

class PeepholeZipupJacketShirt extends React.Component {

    render() {
        return (
            <div>
                <GlobalMetaTags
                    pageTitle={AW21.tops.PeepholeZipupJacketShirt.itemName}
                />
                <Loader />
                <TopMenuProducts
                    name={AW21.tops.PeepholeZipupJacketShirt.itemName}
                />
                <InfoItem
                    price={AW21.tops.PeepholeZipupJacketShirt.itemPrice}
                    fabric={AW21.tops.PeepholeZipupJacketShirt.itemFabric}
                />
                <SizeChart src={AW21.tops.PeepholeZipupJacketShirt.sizeChart} />
                <div className="swiper-container" id="swiper">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.PeepholeZipupJacketShirt.picture01}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.PeepholeZipupJacketShirt.picture02}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.PeepholeZipupJacketShirt.picture03}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.PeepholeZipupJacketShirt.picture04}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.PeepholeZipupJacketShirt.picture05}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.PeepholeZipupJacketShirt.picture06}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.PeepholeZipupJacketShirt.picture07}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
                <ShopifyMainComponent
                    divId={AW21.tops.PeepholeZipupJacketShirt.shopifyDivId}
                    mainId={AW21.tops.PeepholeZipupJacketShirt.shopifyId}
                />
                <SwiperInit />
            </div>
        );
    }
}

export default PeepholeZipupJacketShirt;
